import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import {
  GaTrackingEventName,
  GATrackingEventType,
  GaTrackingEventLabel,
  GaTrackingEventCategory,
} from '../../constants';
import { Product } from '~shared/models';
import get from 'lodash.get';

export class GATrackingSimilarProductsViewEvent implements GATrackingEvent {
  constructor(private products: Product[], private pageName: string, private index: number) {}

  getEventType(): GATrackingEventType {
    return GATrackingEventType.SimilarProductsView;
  }

  getPayload(): GATrackingEventPayload {
    const startIndex = this.index + 1;
    const productPromoViewTracking = {
      category: GaTrackingEventCategory.Ecommerce,
      ecommerce: {
        promoView: {
          promotions: this.products
            .map((product: Product, index: number) => {
              if (product.hasPromotion) {
                return {
                  id: get(product, 'id'),
                  name: get(product, 'name'),
                  list: this.pageName,
                  format: 'carousel',
                  position: index + startIndex,
                };
              }
            })
            .filter(Boolean),
        },
      },
    };

    return {
      event: GaTrackingEventName.PromoView,
      label: GaTrackingEventLabel.PDPCarouselShown,
      gtmCustom: productPromoViewTracking,
    };
  }
}
